/**
 * Regras do funil comercial. A API recusa as etapas de negociação ativa sem
 * próximo passo e data, para que nenhuma Oportunidade em andamento fique sem
 * ação planejada.
 */
export const ETAPAS_COM_PROXIMO_PASSO_OBRIGATORIO = [
    'QUALIFICADO',
    'REUNIAO',
    'PROPOSTA',
    'NEGOCIACAO',
];
export const ETAPAS_ENCERRADAS = ['FECHADO', 'PERDIDO', 'RECICLAGEM'];
/** Etapas que encerram sem venda e exigem motivo registrado. */
export const ETAPAS_COM_MOTIVO_OBRIGATORIO = ['PERDIDO', 'RECICLAGEM'];
/** Etapas em que a Oportunidade ainda está sendo trabalhada. */
export const ETAPAS_ABERTAS = [
    'LEAD',
    'QUALIFICADO',
    'REUNIAO',
    'PROPOSTA',
    'NEGOCIACAO',
];
export function exigeProximoPasso(etapa) {
    return ETAPAS_COM_PROXIMO_PASSO_OBRIGATORIO.includes(etapa);
}
export function exigeMotivo(etapa) {
    return ETAPAS_COM_MOTIVO_OBRIGATORIO.includes(etapa);
}
export function estaEncerrada(etapa) {
    return ETAPAS_ENCERRADAS.includes(etapa);
}
export function estaAberta(etapa) {
    return ETAPAS_ABERTAS.includes(etapa);
}
/** Peso da etapa na fila Atender Agora: negociação madura vem antes. */
export const PESO_ETAPA = {
    NEGOCIACAO: 5,
    PROPOSTA: 4,
    REUNIAO: 3,
    QUALIFICADO: 2,
    LEAD: 1,
    RECICLAGEM: 0,
    FECHADO: 0,
    PERDIDO: 0,
};
export const ROTULO_ETAPA = {
    LEAD: 'Lead',
    QUALIFICADO: 'Qualificado',
    REUNIAO: 'Reunião',
    PROPOSTA: 'Proposta',
    NEGOCIACAO: 'Negociação',
    FECHADO: 'Fechado',
    PERDIDO: 'Perdido',
    RECICLAGEM: 'Reciclagem',
};
//# sourceMappingURL=funil.js.map